<template>
  <upp-menu-central></upp-menu-central>
</template>
<script>

import {mapGetters} from 'vuex'
import UppMenuCentral from "@/components/layouts/menu/UppMenuCentral";

export default {
  name: "HeaderCentral",
  components: {UppMenuCentral},
  props: {
    msg: String
  },
  data: () => ({}),
  computed: {
    ...mapGetters('auth', {
      isAuthenticated: 'isAuthenticated',
      authUser: 'authUser',
      isTypeUser: 'isTypeUser',
      isVerification: 'isVerification'
    }),
  }
}
</script>

<style scoped>

</style>
